import * as Yup from 'yup';

export default Yup.object().shape({
  theme: Yup.string(),
  email: Yup.string().email().required('email required'),
});
